module.exports = __webpack_public_path__ + "src/assets/img/cmd-pre-heater-stop.63b84076.svg";